module.exports = __webpack_public_path__ + "static/media/foto9.5bb853ff.jpg";